/***
 * @file:å­å¨æå¡
 * @author: linkun.he
 * @Date: 2019-03-09 18:56:26
 */
import { Injectable } from '@angular/core';

/**
 * åºååæ°æ®å¹¶å­å¨æ¬å°ç¼å­ä¸­ï¼è¥ä¸ä¼ å¥`local`åæ°åè¡¨ç¤ºå­å¨sessionStorageä¸­
 */
@Injectable({ providedIn: 'root' })
export class StoreService {
  /**
   * åæ°æ®
   * @param key å­å¨çé®
   * @param local trueä»£è¡¨å­å¨localStorageéé¢ï¼ falseä»£è¡¨å­å¨sessionStorageéé¢
   */

  public get(key: string, local?: boolean) {
    return local
      ? JSON.parse(localStorage.getItem(key) || 'null') || null
      : JSON.parse(sessionStorage.getItem(key) || 'null') || null;
  }

  /**
   *  å­æ°æ®
   * @param key å­å¨çé®
   * @param value å­å¨çå¼
   * @param local åä¸
   */
  public set(key: string, value: any, local?: boolean) {
    return local
      ? localStorage.setItem(key, JSON.stringify(value))
      : sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * ç§»é¤æ°æ®
   * @param key ç§»é¤çé®
   * @param local åä¸
   */
  public remove(key: string, local?: boolean) {
    return local ? localStorage.removeItem(key) : sessionStorage.removeItem(key);
  }
}
